import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Icon from "../../images/icon.png";
import { useStyles } from "./css";

import Dialog from "@material-ui/core/Dialog";

const ReturnToSpinner = (props) => {
  const { IsReturnToSpinning } = props;
  const classes = useStyles();

  return (
    <Dialog
    //   onClose={handleClose}
      open={IsReturnToSpinning}
      classes={{ paper: classes.loaderRoot, root: classes.dialogueRoot }}
    >
      <div className={classes.loader} />
      <div className={classes.iconBlock}>
        <img src={Icon} alt="Loading" />
      </div>
    </Dialog>
  );
};

ReturnToSpinner.propTypes = {
  IsReturnToSpinning: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  return {
    IsReturnToSpinning: state.common.IsReturnToSpinning,
  };
};

export default connect(mapStateToProps)(ReturnToSpinner);